export default __webpack_public_path__ + "static/media/logo-lg-2048w.bd6bee6f.avif";